import { render, staticRenderFns } from "./FormAddMO.vue?vue&type=template&id=2877b85b"
import script from "./FormAddMO.vue?vue&type=script&lang=js"
export * from "./FormAddMO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports